/******************************************************************************
 *
 * Our objective is to progress each Ember deprecation warning through:
 *    Logged → Silenced → Thrown → Deleted
 *
 * For more information on how Ember deprecations fit into the Ember v4 upgrade
 * SEE:https://hashicorp.atlassian.net/browse/HCE-30
 *
 *
 * How to resolve Ember deprecation warnings:
 * ------------------------------------------
 * 1. change the override's `handler` property to from ~`silence`~ to `throw`
 * 2. commit your change, and push to git remote so CI can run all the tests
 * 3. see what fails in CI after the deprecated code is made to throw
 * 4. find a way to fix and validate the tests by running the UI locally
 *    and triggering the fixed code locally
 *    (NOTE: deprecated code must be run, static analysis won't catch in build)
 * 5. run through any effected workflows, or anything related locally
 * 6. once everything works in CI, and manual QA locally you're done
 * 7. we'll remove the deprecation override AFTER we upgrade to Ember v4
 *    (until then, throwing in CI will help to avoid regressions)
 *
 * SEE: https://github.com/mixonic/ember-cli-deprecation-workflow#workflow
 *
 *
 * After the Ember v4 upgrade, it would be ideal to configure strict 'catch all'
 * deprecation settings, in order to reduce the amount of refactoring for the
 * next major Ember upgrade we undertake in Cloud UI.
 *
 * SEE: https://github.com/mixonic/ember-cli-deprecation-workflow#catch-all
 *
 *
 ******************************************************************************/

export const config = {
  workflow: [
    // Example: { handler: 'silence', matchId: 'ember-views.curly-components.jquery-element' },
  ],
};

export default function initialize() {
  if (window) {
    if (!window.deprecationWorkflow) {
      window.deprecationWorkflow = {};
    }

    window.deprecationWorkflow.config = config;
  }
}
